import { Radio } from "antd"
import { useFormikContext } from "formik"

interface RadioGroupProps extends React.ComponentProps<typeof Radio.Group> {
  name: string
  placeholderValue?: string
}

export const RadioGroupField = (props: RadioGroupProps) => {
  const {
    name,
    placeholderValue,
    ...radioProps
  } = props

  const formik = useFormikContext()
  const field = formik.getFieldProps(name)

  const getUndefineValueForPlaceholder = (val: string) => { 
    return (placeholderValue && placeholderValue == val) ? undefined : val
  }
  const value = (field.value === undefined && placeholderValue) ? placeholderValue : field.value

  return (
    <Radio.Group
      {...radioProps}

      value={value}
      onChange={(e) => formik.setFieldValue(field.name, getUndefineValueForPlaceholder(e.target.value))}
    />
  )
}

export default RadioGroupField